import React from "react";
import Lotties from "../helpers/Lotties";

export default class Lottie extends React.Component {
  render() {
    const lottie = this.props.lottie;
    return <lottie-player src={Lotties[lottie].src} style={Lotties[lottie].style} loop={Lotties[lottie].loop ? true : undefined} autoplay speed={Lotties[lottie].speed || 1} />;
  }
}